(()=>{
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initReveal=()=>{
    document.documentElement.classList.add('od-motion-ready');
    const els=document.querySelectorAll('.od-reveal');
    if(reduce||!('IntersectionObserver' in window)){els.forEach(el=>el.classList.add('is-visible'));return;}
    const io=new IntersectionObserver(entries=>entries.forEach(entry=>{
      if(entry.isIntersecting){entry.target.classList.add('is-visible');io.unobserve(entry.target)}
    }),{threshold:.08,rootMargin:'0px 0px -40px'});
    els.forEach(el=>io.observe(el));
  };

  const initCarousel=()=>{
    document.querySelectorAll('[data-od-product-carousel]').forEach(root=>{
      const track=root.querySelector('[data-carousel-track]');
      const prev=root.querySelector('[data-carousel-prev]');
      const next=root.querySelector('[data-carousel-next]');
      if(!track||!prev||!next)return;
      const cards=[...track.querySelectorAll('.od-product-choice')];
      const step=()=>cards[0] ? cards[0].getBoundingClientRect().width+16 : track.clientWidth*.8;
      const update=()=>{
        const max=Math.max(0,track.scrollWidth-track.clientWidth-2);
        prev.disabled=track.scrollLeft<=2;
        next.disabled=track.scrollLeft>=max;
      };
      prev.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:reduce?'auto':'smooth'}));
      next.addEventListener('click',()=>track.scrollBy({left:step(),behavior:reduce?'auto':'smooth'}));
      track.addEventListener('scroll',()=>requestAnimationFrame(update),{passive:true});
      window.addEventListener('resize',update,{passive:true});
      update();
    });
  };

  const initScrollLogo=()=>{
    const section=document.querySelector('[data-od-scroll-logo]');
    if(!section)return;
    if(reduce){section.style.setProperty('--od-logo-progress','1');section.style.setProperty('--od-logo-gap','.5px');return;}
    let ticking=false;
    const update=()=>{
      const rect=section.getBoundingClientRect();
      const distance=Math.max(1,section.offsetHeight-window.innerHeight);
      const progress=Math.min(1,Math.max(0,-rect.top/distance));
      const maxGap=window.innerWidth<=900?8:Math.min(25,Math.max(5,window.innerWidth*.015));
      section.style.setProperty('--od-logo-progress',progress.toFixed(3));
      section.style.setProperty('--od-logo-gap',`${(.5+(1-progress)*maxGap).toFixed(2)}px`);
      ticking=false;
    };
    const requestUpdate=()=>{if(!ticking){ticking=true;requestAnimationFrame(update)}};
    window.addEventListener('scroll',requestUpdate,{passive:true});
    window.addEventListener('resize',requestUpdate,{passive:true});
    update();
  };

  const initProductEntry=()=>{
    document.querySelectorAll('[data-od-product-link]').forEach(link=>{
      link.addEventListener('click',()=>{
        try{sessionStorage.setItem('od_show_first_purchase','1')}catch(e){}
      });
    });
  };

  const initWelcome=()=>{
    const dialog=document.querySelector('[data-od-welcome-dialog]');
    if(!dialog)return;
    let shouldShow=false;
    try{
      shouldShow=sessionStorage.getItem('od_show_first_purchase')==='1' && localStorage.getItem('od_first_purchase_seen')!=='1';
      sessionStorage.removeItem('od_show_first_purchase');
    }catch(e){}
    if(shouldShow){setTimeout(()=>dialog.showModal?.(),250)}
    const markSeen=()=>{try{localStorage.setItem('od_first_purchase_seen','1')}catch(e){}}
    dialog.querySelector('[data-od-welcome-close]')?.addEventListener('click',()=>{markSeen();dialog.close()});
    dialog.addEventListener('click',e=>{if(e.target===dialog){markSeen();dialog.close()}});
    dialog.addEventListener('close',markSeen);
    dialog.querySelector('[data-copy-coupon]')?.addEventListener('click',async e=>{
      const btn=e.currentTarget; const code=btn.dataset.copyCoupon||'PRIMEIRA10';
      try{await navigator.clipboard.writeText(code);btn.textContent='Copiado';setTimeout(()=>btn.textContent='Copiar',1800)}catch(err){}
    });
  };

  const boot=()=>{initReveal();initScrollLogo();initCarousel();initProductEntry();initWelcome();};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
